import { SessionStatus } from '@texas/api/endpoints/sessionApi';
import { useSession } from '@texas/hooks/useSession';

interface ActiveSessionProps {
  children: React.ReactNode;
}

export function ActiveSession({ children }: ActiveSessionProps) {
  const { sessionState } = useSession();

  if (sessionState.status !== SessionStatus.Active) {
    return null;
  }

  return <>{children}</>;
}
